import client from '../../../utils/api';
import { createApiAction } from '../../../utils/redux-tool';

export const search = createApiAction(
  'academic/esign/search',
  client.search('/api/student/:memberId/form')
);

export const save = createApiAction(
  'academic/esign/save',
  client.save('/api/student/:memberId/form')
);

export const get = createApiAction(
  'academic/esign/get',
  client.retrieve('/api/student/:memberId/form/:id')
);

const update = (state, action) => {
  const found = state.esign?.list?.find(rec => rec.id === action.payload.id)
  state.esign.list = found
    ? state.esign?.list.map(item => (found.id === item.id ? action.payload : item))
    : [...state.esign.list, action.payload]
}

export default function setEsignReducer(builder) {
  builder.addCase(search.fulfilled, (state, action) => {
    state.esign.list = action.payload;
  });

  builder.addCase(save.fulfilled, update)
  builder.addCase(get.fulfilled, update)
}
